export const DATA_TYPES = ["pefr", "fev1", "fvc", "fev6", "fef2575"]

export const LABELNAMES = {
  "pefr": "PEFR",
  "fev1": "FEV₁",
  "fvc": "FVC",
  "fef2575": "FEF₂₅₋₇₅",
  "fev6": "FEV₆"
}